import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _ from 'lodash';
import { getShow as show } from '../../lib/show';
import { getMyAccountUrl } from '../../lib/getWLSAssetsUrl';

const Header = styled.header`
  background: ${(props) => props.theme.colours.primary};
  display: flex;
  align-items: center;
  flex-shrink: 0;
  min-height: 100px;
  position: sticky;
  top: 0;
  z-index: 100;

  @media (max-width: 767px) {
    min-height: 120px;
    align-items: ${props => props.hasSignOut ? 'flex-start' : 'center'};
  }
  
  @media (max-width: 480px) {
    justify-content: flex-end;
    padding: 0;
  }
  
  @media (max-width: 320px) {
  ${props => !props.hasSignOut && `
    flex-direction: column;
    gap: 4px;
    justify-content: center;
    padding: 0;
  `
  }
}
`;

const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 16px 24px;
  box-sizing: border-box;

  display: grid;
  grid-template-areas: "brand signout";
  grid-template-columns: auto auto;
  align-items: center;
  justify-content: space-between;

  min-height: 68px;

  @media (max-width: 767px) {
    grid-template-areas: ${props => props.hasSignOut 
    ? '"signout" "brand"' 
    : '"brand"'};
    grid-template-columns: 1fr;
    justify-content: stretch;
    align-items: center;
    padding: ${props => props.hasSignOut ? '0 4px 0px 24px;' : '0 4px 2.5px 24px'};
  }
`;

const BrandSection = styled.div`
  grid-area: brand;
  display: flex;
  align-items: center;
  height: 48px;
  cursor: pointer;
  @media (max-width: 767px) {
    margin-top: 23.5px;
  }
`;

const Logo = styled.div`
  height: 32.5px;
  width: 150px;
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url(${(props) => _.get(props.theme, 'assets.brand', 'none')});
  background-position: left center;
  cursor: pointer;
`;

const Divider = styled.div`
  width: 1px;
  height: 48px;
  background-color: #C6C6C6;
  font-weight: 500;
  align-self: stretch;
  margin: 0 16px;
`;

const Title = styled.p`
  color: white;
  font-size: 18px;
  font-weight: 700;
  @media screen and (min-width: 768px) {
    font-size: 20px;
  }
`;

const SignOutButton = styled.a`
  grid-area: signout;
  color: white !important;
  font-family: Montserrat !important;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
  text-decoration: none !important;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  text-wrap: nowrap;
  border-radius: 3px !important;

  @media (max-width: 767px) {
    justify-self: flex-end;
    margin-top: 4px;
  }
`;


const SignOutText = styled.span`
  &:hover {
    text-decoration: underline;
  }
`;

const SignOutIcon = styled.svg`
  fill: white;
  &:hover {
    fill: white !important;
  }
  
  @media (min-width: 768px) {
    width: 24px;
    height: 24px;
  }
`;

const WLSHeader = ({ session }) => {
  const isLoggedIn = session && session.token;
  const showLogout = show('logout', true); 
  const hasSignOut = isLoggedIn && showLogout;

  const handleBrandClick = () => {
    window.open(getMyAccountUrl(), '_blank', 'noopener,noreferrer');
  };

  return (
    <Header hasSignOut={hasSignOut}>
      <Container hasSignOut={hasSignOut}>
        <BrandSection hasSignOut={hasSignOut} onClick={handleBrandClick}>
          <Logo />
          <Divider />
          <Title>Account</Title>
        </BrandSection>
        {hasSignOut && (
        <SignOutButton href="/logout">
          <SignOutText>Sign out</SignOutText>
          <SignOutIcon xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="white">
            <path d="M11.3334 4.66667L10.3934 5.60667L12.1134 7.33333H5.33337V8.66667H12.1134L10.3934 10.3867L11.3334 11.3333L14.6667 8L11.3334 4.66667ZM2.66671 3.33333H8.00004V2H2.66671C1.93337 2 1.33337 2.6 1.33337 3.33333V12.6667C1.33337 13.4 1.93337 14 2.66671 14H8.00004V12.6667H2.66671V3.33333Z" fill="white" />
          </SignOutIcon>
        </SignOutButton>
      )}
      </Container>
    </Header>
  );
};

WLSHeader.defaultProps = {
  session: undefined
};

WLSHeader.propTypes = {
  session: PropTypes.shape({
    token: PropTypes.string
  })
};

export default WLSHeader;